<template>
  <div class="custom-tabbar" ref="custom-tabbar">

    <van-tabbar :z-index="999" @change="onChange" :value="tabActiveGetter" active-color="#0a1450" inactive-color="#999">
      <template v-for="(item,index) in list">
        <van-tabbar-item :name="item.pagePath" :key="index">
          <span>{{ item.text }}</span>
          <template #icon>
            <img v-if="tabActiveGetter === item.pagePath" :src="item.selectedIconPath"/>
            <img v-else :src="item.iconPath"/>
          </template>
        </van-tabbar-item>

      </template>
    </van-tabbar>
  </div>
</template>

<script>
import _ from 'loadsh'

export default {
  name: "customTabbar",
  data() {
    return {
      list: [
        {
          "pagePath": "/home",
          "text": "主页",
          "iconPath": require("@/assets/img/tabbar/2.png"),
          "selectedIconPath": require("@/assets/img/tabbar/1.png")

        },
        {
          "pagePath": "/task",
          "text": "任务",
          "iconPath": require("@/assets/img/tabbar/10.png"),
          "selectedIconPath": require("@/assets/img/tabbar/9.png"),
          categoryId:1
        },
        {
          "pagePath": "/learning",
          "text": "学习",
          "iconPath": require("@/assets/img/tabbar/4.png"),
          "selectedIconPath": require("@/assets/img/tabbar/3.png"),
          categoryId:3
        },
        {
          "pagePath": "/ranks",
          "text": "队伍",
          "iconPath": require("@/assets/img/tabbar/6.png"),
          "selectedIconPath": require("@/assets/img/tabbar/5.png")
        },
        {
          "pagePath": "/my",
          "text": "我的",
          "iconPath": require("@/assets/img/tabbar/8.png"),
          "selectedIconPath": require("@/assets/img/tabbar/7.png")
        },
      ]
    }
  },
  watch: {
    $route: {
      handler() {
        this.$store.commit("setTabActive", this.$route.path);
      },
      deep: true,
      immediate: true
    }

  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.$refs["custom-tabbar"].offsetHeight);
      this.$store.commit("setTabHeight", this.$refs["custom-tabbar"].offsetHeight);
    });
  },
  methods: {
    onChange(path) {
      console.log(path);

      console.log();
      if (!this.tokenGetter && path !== '/home') {
        this.$store.commit("setNavigateTo");
        return
      }
      this.$router.push(path)
    },
  }
}
</script>

<style scoped lang="scss">
.custom-tabbar {
  ::v-deep .van-tabbar {
    padding-bottom: 10px;

  }
}
</style>
